import { render } from "./BeneficiaryCard.vue?vue&type=template&id=5fd59583"
import script from "./BeneficiaryCard.vue?vue&type=script&lang=js"
export * from "./BeneficiaryCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\supportgroup\\head.supportgroup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__